import { __assign } from "tslib";
import axios from 'axios';
import { ApiTypes } from '../sdk';
var DEFAULT_BASE_URL = "https://www.wix.com";
var maxSuggestQueryLength = 100;
function trimTrailingSlash(url) {
    return url.replace(/\/$/, '');
}
var SearchApi = /** @class */ (function () {
    function SearchApi(config) {
        this.axios = axios.create({
            baseURL: trimTrailingSlash(config.baseURL || DEFAULT_BASE_URL) + "/search-services-reader",
            timeout: config.timeout,
            headers: {
                Authorization: config.token,
            },
        });
    }
    SearchApi.getDocumentTypesUrl = function () {
        return '/v1/search/sources';
    };
    SearchApi.getSearchUrl = function () {
        return '/v1/search';
    };
    SearchApi.getSuggestionsUrl = function () {
        return '/v1/suggest';
    };
    SearchApi.getFederatedSuggestionsUrl = function () {
        return '/v1/suggest/federated';
    };
    SearchApi.getSampleUrl = function () {
        return '/v1/search/federated';
    };
    SearchApi.prototype.setToken = function (token) {
        this.axios.defaults.headers.common.Authorization = token;
    };
    SearchApi.prototype.getInstance = function () {
        return this.axios;
    };
    SearchApi.prototype.getFieldsByDocumentType = function (searchRequest) {
        var _a;
        if (!searchRequest.documentType) {
            return;
        }
        var fieldsByDocumentType = (_a = {},
            _a[ApiTypes.SearchDocumentType.Products] = ['discountedPrice'],
            _a[ApiTypes.SearchDocumentType.Events] = [
                'currency',
                'eventType',
                'location',
                'maxPrice',
                'minPrice',
                'startDate',
            ],
            _a)[searchRequest.documentType] || [];
        return ['description', 'title', 'id'].concat(fieldsByDocumentType);
    };
    SearchApi.prototype.getExtraSearchRequestParams = function (searchRequest) {
        return {
            fuzzy: true,
            fields: this.getFieldsByDocumentType(searchRequest),
        };
    };
    SearchApi.prototype.getExtraSampleRequestParams = function () {
        return {
            fuzzy: true,
        };
    };
    SearchApi.prototype.getDocumentTypes = function () {
        return this.axios.get(SearchApi.getDocumentTypesUrl());
    };
    SearchApi.prototype.search = function (searchRequest) {
        var params = __assign(__assign({}, searchRequest), this.getExtraSearchRequestParams(searchRequest));
        return this.axios.post(SearchApi.getSearchUrl(), params);
    };
    SearchApi.prototype.getFederatedSuggestions = function (suggestionsRequest) {
        var params = suggestionsRequest;
        params.query = params.query.substring(0, maxSuggestQueryLength);
        return this.axios.post(SearchApi.getFederatedSuggestionsUrl(), params);
    };
    SearchApi.prototype.getSample = function (sampleRequest) {
        return this.axios.post(SearchApi.getSampleUrl(), __assign(__assign({}, sampleRequest), this.getExtraSampleRequestParams()));
    };
    return SearchApi;
}());
export { SearchApi };
//# sourceMappingURL=api.js.map